import { render, staticRenderFns } from "./BasisListItem.vue?vue&type=template&id=32b01094&scoped=true&"
import script from "./BasisListItem.vue?vue&type=script&lang=js&"
export * from "./BasisListItem.vue?vue&type=script&lang=js&"
import style0 from "./BasisListItem.vue?vue&type=style&index=0&id=32b01094&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b01094",
  null
  
)

export default component.exports